import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Box,
  Dialog,
  DialogContent,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { MarketHeader } from '@market/react';

/**
 * NOTE: This component is currently highly coupled with the design for the
 * Square Register comparison modal. If we need to reuse this component for
 * other product comparisons, a refactor will likely be necessary to make it
 * more generic and configurable.
 */
const ProductComparisonModal = (props) => {
  const theme = useTheme();
  const { t } = useTranslation();

  const { open, handleClose } = props;

  return (
    <Dialog
      fullWidth
      maxWidth="sm"
      fullScreen={useMediaQuery(theme.breakpoints.down('sm'))}
      open={open}
      onClose={handleClose}
      data-market-features="typography,html-styles"
    >
      <MarketHeader
        showNavigation
        onMarketHeaderNavigate={handleClose}
        style={{ margin: theme.spacing(4, 4, 0) }}
      >
        <h1>{t('productPage.comparisonModal.register.title')}</h1>
      </MarketHeader>

      <DialogContent sx={{ pt: 2, pb: 4, px: 4 }}>
        <Box sx={{ py: 1 }}>
          <Box component="p" className="paragraph-30" sx={{ mb: 2 }}>
            {t('productPage.comparisonModal.register.intro')}
          </Box>
          <Box
            component="p"
            className="paragraph-30"
            sx={{ mb: 1 }}
            style={{ fontWeight: 'bold' }}
          >
            {t('productPage.comparisonModal.register.differencesTitle')}
          </Box>
          <Box
            component="p"
            className="paragraph-30"
            sx={{ mb: 1 }}
            dangerouslySetInnerHTML={{
              __html: t(
                'productPage.comparisonModal.register.differenceMemory',
              ),
            }}
          />
          <Box
            component="p"
            className="paragraph-30"
            sx={{ mb: 1 }}
            dangerouslySetInnerHTML={{
              __html: t(
                'productPage.comparisonModal.register.differenceStorage',
              ),
            }}
          />
          <Box
            component="p"
            className="paragraph-30"
            sx={{ mb: 2 }}
            dangerouslySetInnerHTML={{
              __html: t(
                'productPage.comparisonModal.register.differenceDurability',
              ),
            }}
          />
          <Box
            component="p"
            className="paragraph-30"
            sx={{ mb: 1 }}
            style={{ fontWeight: 'bold' }}
          >
            {t('productPage.comparisonModal.register.chooseTitle')}
          </Box>
          <Box
            component="ul"
            sx={{
              mb: 2,
              pl: 3,
              '& li': {
                mb: 1,
                listStyleType: 'disc',
                '&::marker': {
                  color: theme.color?.blue || '#006aff',
                },
              },
            }}
          >
            <Box component="li" className="paragraph-30">
              {t('productPage.comparisonModal.register.chooseList.item1')}
            </Box>
            <Box component="li" className="paragraph-30">
              {t('productPage.comparisonModal.register.chooseList.item2')}
            </Box>
            <Box component="li" className="paragraph-30">
              {t('productPage.comparisonModal.register.chooseList.item3')}
            </Box>
          </Box>
          <Box component="p" className="paragraph-30" sx={{ mb: 0 }}>
            {t('productPage.comparisonModal.register.footer')}
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default ProductComparisonModal;
